import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=5ec6117e&scoped=true"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"
import style0 from "./Positions.vue?vue&type=style&index=0&id=5ec6117e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6117e",
  null
  
)

export default component.exports